import { useSuspenseQuery } from '@tanstack/react-query';

import { getMebiConn } from '../api';
import { QUERY_KEYS } from '../consts';

export const useSuspenseGetMebiconn = (params) => {
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.nonMemberPtInfo],
    queryFn: getMebiConn(params),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
